exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".page-header{height:80px;width:100%;position:relative;background-image:url(" + require("./bg-header.png") + ");background-repeat:repeat-x;background-color:#76c7c0;z-index:1}.header-logo{position:absolute;top:25px;left:3px}.header-menu{position:absolute;left:450px;top:5px}.header-search{position:absolute;top:20px;left:1050px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-def3f26e","scoped":false,"hasInlineConfig":true}!./src/components/page-header/page-header.css
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-compiler/index.js?{"vue":true,"id":"data-v-def3f26e","scoped":false,"hasInlineConfig":true}!./src/components/page-header/page-header.css
// module chunks = index